module.exports = __webpack_public_path__ + "img/confounder_bmi_chd.3efa6880.png";